import React from 'react'

import {SessionsStorage} from 'storage/Session.jsx'
import {TokenTable} from './Tokens.jsx'

export const Sessions = props => (
   <div className="userauth tokens">
      <div className="page-header">
         <h1>Your Sessions</h1>
      </div>
      <SessionsStorage {...props}>
         <TokenTable tokens={[]} />
      </SessionsStorage>
   </div>
)



// WEBPACK FOOTER //
// lib/bundle/user/Sessions.jsx